(() => {
  const MAX_FILE_BYTES = 10 * 1024 * 1024;
  const imageType = bytes => {
    if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return 'image/jpeg';
    if ([137, 80, 78, 71, 13, 10, 26, 10].every((v, i) => bytes[i] === v)) return 'image/png';
    if (String.fromCharCode(...bytes.slice(0, 4)) === 'RIFF' && String.fromCharCode(...bytes.slice(8, 12)) === 'WEBP') return 'image/webp';
    return null;
  };
  const init = root => {
    root.querySelectorAll('[data-comparison]').forEach(container => {
      if (container.dataset.bound) return;
      container.dataset.bound = 'true';
      container.querySelector('input').addEventListener('input', event => container.style.setProperty('--tr-compare', `${event.target.value}%`));
    });
    root.querySelectorAll('[data-personalizer]').forEach(container => {
      if (container.dataset.bound) return;
      container.dataset.bound = 'true';
      const form = container.querySelector('.tr-portrait-form');
      const primary = container.querySelector('[data-product-submit]');
      const buyNow = container.querySelector('[data-buy-now]');
      const input = container.querySelector('[data-photo-input]');
      const photoPreview = container.querySelector('[data-photo-preview]');
      const photoStatus = container.querySelector('[data-photo-status]');
      const photoReference = container.querySelector('[data-photo-reference]');
      const error = container.querySelector('[data-product-error]');
      const status = container.querySelector('[data-product-status]');
      const idInput = container.querySelector('[data-variant-id]');
      const demo = container.dataset.demo === 'true';
      const variants = JSON.parse(container.querySelector('[data-variants]').textContent);
      const currency = container.dataset.currency || 'EUR';
      let selected = null;
      let validFile = null;
      let objectUrl = null;
      let validationSequence = 0;
      let busy = false;
      const setError = message => {
        error.textContent = message;
        error.hidden = !message;
      };
      const setFrame = value => {
        const framed = /emoldurado/i.test(value || '');
        container.querySelector('[data-frame-field]').hidden = !framed;
        container.querySelector('[data-frame-select]').disabled = !framed;
      };
      const updateVariant = () => {
        const options = [...container.querySelectorAll('[data-option-index]:checked')].sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)).map(radio => radio.value);
        if (!variants.length) {
          setFrame(container.querySelector('[data-demo-format]:checked')?.value);
          document.dispatchEvent(new CustomEvent('trazzo:product-size', {detail:{size:container.querySelector('[name="demo-size"]:checked')?.value || ''}}));
          return;
        }
        selected = variants.find(variant => variant.options.every((option, index) => option === options[index]));
        idInput.value = selected?.id || '';
        setFrame(selected?.options[0]);
        document.dispatchEvent(new CustomEvent('trazzo:product-size', {detail:{size:selected?.options[1] || ''}}));
        if (!demo) {
          const available = selected?.available && selected.price > 0;
          primary.disabled = !available || busy;
          if (buyNow) buyNow.disabled = !available || busy;
          primary.childNodes[0].textContent = available ? container.dataset.add : container.dataset.unavailable;
          if (selected) {
            const price = new Intl.NumberFormat('pt-PT', { style: 'currency', currency }).format(selected.price / 100);
            container.querySelector('[data-product-price]').textContent = price;
            const stickyPrice = container.querySelector('[data-sticky-price]');
            if (stickyPrice) stickyPrice.textContent = price;
          }
        }
      };
      container.querySelectorAll('[data-option-index],[data-demo-format],[name="demo-size"]').forEach(radio => radio.addEventListener('change', updateVariant));
      const recipient = container.querySelector('[data-recipient]');
      const recipientQuery = new URL(window.location.href).searchParams.get('destinatario');
      const initialRecipient = [...recipient.options].find(option => option.dataset.value === recipientQuery);
      if (initialRecipient) recipient.value = initialRecipient.value;
      recipient.addEventListener('change', () => document.dispatchEvent(new CustomEvent('trazzo:personalization', { detail: { stage: 'recipient_selected' } })));
      input.addEventListener('change', async () => {
        const sequence = ++validationSequence;
        validFile = null;
        photoReference.value = '';
        input.setCustomValidity('');
        setError('');
        photoStatus.textContent = '';
        photoPreview.hidden = true;
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = null;
        document.dispatchEvent(new CustomEvent('trazzo:photo-preview', { detail: { url: null } }));
        const file = input.files?.[0];
        if (!file) return;
        try {
          if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) throw new Error(container.dataset.errorType);
          if (file.size === 0 || file.size > MAX_FILE_BYTES) throw new Error(container.dataset.errorSize);
          const signature = imageType(new Uint8Array(await file.slice(0, 16).arrayBuffer()));
          if (signature !== file.type) throw new Error(container.dataset.errorType);
          const bitmap = await createImageBitmap(file);
          const acceptable = bitmap.width >= 600 && bitmap.height >= 600 && bitmap.width * bitmap.height <= 40000000;
          bitmap.close();
          if (!acceptable) throw new Error(container.dataset.errorInvalid);
          if (sequence !== validationSequence) return;
          validFile = file;
          objectUrl = URL.createObjectURL(file);
          photoPreview.src = objectUrl;
          document.dispatchEvent(new CustomEvent('trazzo:photo-preview', { detail: { url: objectUrl } }));
          photoPreview.hidden = false;
          photoStatus.textContent = container.dataset.fileReady;
          document.dispatchEvent(new CustomEvent('trazzo:personalization', { detail: { stage: 'photo_validated' } }));
        } catch (failure) {
          if (sequence !== validationSequence) return;
          const message = failure.message === container.dataset.errorType || failure.message === container.dataset.errorSize || failure.message === container.dataset.errorInvalid ? failure.message : container.dataset.errorInvalid;
          input.setCustomValidity(message);
          photoStatus.textContent = message;
          input.reportValidity();
        }
      });
      container.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
        const image = container.querySelector('.tr-product-main-image > img');
        if (!image) return;
        image.removeAttribute('srcset');
        image.src = button.dataset.gallerySrc;
        image.alt = button.dataset.galleryAlt;
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (demo || busy) return;
        if (!form.reportValidity() || !validFile || !selected?.available || selected.price <= 0) return;
        const cartData = new FormData(form);
        const submissionPhoto = validFile;
        const controls = [...form.elements].map(control => [control, control.disabled]);
        controls.forEach(([control]) => { control.disabled = true; });
        setError('');
        busy = true;
        primary.disabled = true;
        if (buyNow) buyNow.disabled = true;
        primary.setAttribute('aria-busy', 'true');
        try {
          const endpoint = new URL(container.dataset.uploadEndpoint, window.location.origin);
          if (endpoint.protocol !== 'https:' || endpoint.origin !== window.location.origin || !endpoint.pathname.startsWith('/apps/')) throw new Error(container.dataset.errorNetwork);
          if (!photoReference.value) {
            status.textContent = container.dataset.uploading;
            const photoData = new FormData();
            photoData.append('photo', submissionPhoto);
            const uploadResponse = await fetch(endpoint.href, { method: 'POST', body: photoData, credentials: 'omit', signal: AbortSignal.timeout(60000) });
            if (!uploadResponse.ok) throw new Error(container.dataset.errorNetwork);
            const upload = await uploadResponse.json();
            if (typeof upload.id !== 'string' || !/^[a-zA-Z0-9_-]{22,128}$/.test(upload.id)) throw new Error(container.dataset.errorNetwork);
            photoReference.value = upload.id;
          }
          cartData.set('properties[_trazzo_photo_id]', photoReference.value);
          const response = await fetch(form.action.endsWith('.js') ? form.action : `${form.action.replace(/\/$/, '')}.js`, { method: 'POST', body: cartData, headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(30000) });
          if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            throw new Error(typeof body.description === 'string' ? body.description : container.dataset.addError);
          }
          if(event.submitter?.hasAttribute('data-buy-now')) window.location.assign(new URL(`${window.Shopify?.routes?.root || '/'}checkout`,window.location.origin).href);
          else if(window.TrazzoCart) window.TrazzoCart.open();
          else window.location.assign(container.dataset.cartUrl);
        } catch (failure) {
          setError(failure.name === 'TimeoutError' ? container.dataset.errorNetwork : failure.message || container.dataset.addError);
          status.textContent = '';
        } finally {
          busy = false;
          controls.forEach(([control, disabled]) => { control.disabled = disabled; });
          primary.removeAttribute('aria-busy');
          updateVariant();
        }
      });
      const sticky = container.querySelector('[data-sticky-cart]');
      if (sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          sticky.hidden = entries[0].isIntersecting || window.scrollY < container.offsetTop + 250;
        });
        observer.observe(primary);
        container.querySelector('[data-sticky-submit]').addEventListener('click', () => {
          form.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          if (demo) { input.focus({ preventScroll: true }); } else { form.requestSubmit(primary); }
        });
      }
      updateVariant();
    });
  };
  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.tr-mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  });
  document.addEventListener('click', event => {
    const menu = document.querySelector('.tr-mobile-menu[open]');
    if (menu && (!menu.contains(event.target) || event.target.closest('a'))) menu.removeAttribute('open');
  });
})();
